var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#9696b9;stroke:#9696b9;stroke-width:0.5px;}.b,.d{fill:none;}.b{stroke:#f8f8f8;stroke-linecap:round;stroke-width:1.8px;}.c{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 15,
    height: 15,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 14.5,
    rx: 2.75
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.719, -0.695, 0.695, 0.719, 2.338, 7.242)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 7.059,
    transform: "translate(3.471)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 7.06,
    transform: "translate(7.06 3.737) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.c32e7c143cd328553bf34b5b0e1ba47a.svg";
export { ForwardRef as ReactComponent };